import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

// Used 23x across 17 files — hide on mobile, show on desktop
export const DesktopOnly = styled(Box)(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('lg')]: {
    display: 'block',
  },
}));

// Used 16x across 10 files — show on mobile, hide on desktop
export const MobileOnly = styled(Box)(({ theme }) => ({
  display: 'block',
  [theme.breakpoints.up('lg')]: {
    display: 'none',
  },
}));
